module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch9"
    }
  }, [_vm._v("FUSION TORCH SHIP "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("AUSTRALIA")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("“What’s so great about Earth?” Corvus asked, looking puzzled. “I’ve lived there most of my life. It’s no big thrill.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before Deirdre could think of a reply, Dorn said gravely, “I can see where Dee would be excited about it. If you’ve never been there before, well … it "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is")]), _vm._v(" big, and lots of it is still quite beautiful. The tropical rain forests—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s left of them,” Corvus grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The open plains, the mountains, the oceans. They truly are beautiful, more beautiful than any space habitat, certainly.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Corvus shrugged impatiently. “And the cities, with the crowds and crooks, the noise, the dirt, the diseases.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t you like Earth, Andy?” Deirdre asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His expression softened. “Oh, I guess so. But it’s not paradise, believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I still want to see it, experience it,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s worth seeing,” said Dorn, almost wistfully.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why are you going to Jupiter, Andy?” Deirdre asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Corvus made a half-embarrassed grin, glanced at the cyborg, then looked back at her. “I’m going to make contact with those big critters in the ocean there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Make contact with the leviathans?” Dorn said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bobbing his head up and down, Corvus said, “Yep. The leviathans.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Make contact?” Deirdre prodded. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Both hands fidgeting with his tall beer glass, Corvus replied, “You know what DBS is?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s a sort of brain probe, isn’t it?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sort of. But it’s more than that. A lot more. Deep brain stimulation. It’s a whole new field.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Didn’t they try treating cases of depression that way?” Deirdre asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Corvus waved a hand in the air. “It didn’t really treat depression. It just tranquilized the patient so he didn’t show any symptoms anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The zombie machine,” Dorn muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s what some people call it,” Corvus said, looking slightly nettled. “They used it on convicts in jail. Kept them pacified, cut down on prison violence. A lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But the suicide rate tripled.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre said, “You seem to know a lot about it, Dorn.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The human half of his face twitched into what might have been a grimace. “I’ve received an accelerated education on the subject.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How come?” Corvus asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Flexing his prosthetic hand, Dorn replied, “I have been hired by the scientific directors of station "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gold")]), _vm._v(" as a sort of experimental animal. They want to see how my body might be advantageous when it comes to probing Jupiter’s ocean. For the past year I’ve been a prime research specimen at Selene University, on the Moon.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ooh.” Corvus’s face lit up with understanding. “Being half mechanical, you might be able to take the pressures of a deep dive better, is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Humans haven’t gone down into the Jovian ocean in twenty years,” Deirdre said. “They tried two crewed dives and both were disasters.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Still,” said Dorn, “the scientists would like to go deep enough into the ocean to observe the leviathans.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They send automated probes down deep,” Corvus said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dorn nodded. “Now they want to send people.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But why?” asked Deirdre. “It’s so dangerous! And the robot probes can do anything people can do, can’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Corvus shook his head. “They can do everything except react to the unexpected, Dee. The robots can only answer the questions that we knew how to ask before they go into the water. You can’t program a computer to handle unexpected situations.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You can link human controllers,” she pointed out. “Have them in charge in real time so that—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dorn interrupted her. “As I understand it, the probes must go so deep into the ocean that they can’t maintain contact with the orbiting station. Electronic signals can’t penetrate the depth of water. Not even laser beams can get through.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Couldn’t they put relay stations into the ocean?” Deirdre asked. “They could pass the signals—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s too deep,” Corvus interrupted. “And the relays would have to stay more or less fixed in position.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Impossible in the currents of that ocean,” added Dorn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre said, “Oh. So that’s why they want to send humans again.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Both men nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But it’s so dangerous!” Deirdre exclaimed again. “Who would want to go down there?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I would,” Corvus answered, without a microsecond’s hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre looked aghast at the idea. “Why would you—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“To make contact with the leviathans,” Corvus said before she could finish her question.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Using DBS?” Dorn asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bobbing his head again, Corvus said, “It’s a variation of the deep brain stimulation concept. You can link your brain to the brain of another person. It was originally developed for the intelligence services, and police. You know, you can probe a person’s brain, pull out everything he knows, whether he likes it or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is that legal?” Deirdre wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ignoring her question, Corvus went on, fairly trembling with growing enthusiasm, “Well, back at the University of Rome, our professor got the idea of linking with nonhuman animals. Great for biological studies. Ecological, too. You can experience what an antelope or a lion experiences, see the world the way they see it. We started out with elephants, then chimpanzees. The anthropologists went crazy over it!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I can imagine,” Dorn muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, seriously,” Corvus said eagerly. “I was one of Professor Carbo’s best students. I could link more easily than any of the others. I was an elephant out in the Serengeti for a solid week!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre giggled. “I hope it wasn’t mating season.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Looking almost hurt, Corvus said, “This is the only way we’re going to make any meaningful contact with the leviathans. Using neuro-optronic probes to link our brains with theirs.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Assuming the leviathans have brains,” Dorn said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’ve got to! Critters that big? They’ve got to have a central nervous system with a brain to direct those enormous bodies.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dorn shook his head slightly. “You’re assuming that Jovian biology works on the same principles as our own. We have no way of knowing that’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wrong!” Corvus snapped. “We’ve studied those living balloons that float through the Jovian atmosphere, and some of the other airborne creatures. They all have brains.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you intend to try to link with them before you try to reach the leviathans?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I sure do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deirdre put a hand on Corvus’s arm. “Andy, does that mean you’ll have the linking equipment implanted in your own brain?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Doesn’t have to be implanted,” Corvus said. Tapping his temple, he explained, “You just fit the sensors on your head, like a crown.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But how will you fit the sensors on the leviathans?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Corvus’s enthusiasm wavered the slightest bit. “Well, we’ll have to get close enough to one of ’em so we can attach a sensor rig to its hide.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Like harpooning a whale?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Shades of Moby Dick,” Dorn muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And you intend to go down into the ocean and do this yourself?” Deirdre asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Corvus nodded. “Yep. Sure do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The three of them looked at each other, none of them knowing what to say next.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“DINNER IS SERVED IN THE MAIN DINING ROOM,” announced the ship’s intercom through the speakers set into the lounge’s overhead.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ac8404","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter9.vue
// module id = 102
// module chunks = 0